import { BaseValidator } from './base';
import { call, put, fork, select, take, takeEvery } from 'redux-saga/effects';
import { api }                from 'apps/api'
import { VALID_USER }         from 'apps/action_types';
import { FSA }                from 'flux-standard-action';
import { update }             from 'apps/actions/data';
import { deepmerge }          from 'utilities/merge';
import isEmail                from 'validator/lib/isEmail';
import isEmpty                from 'validator/lib/isEmpty';
import { newDataFromDot }     from 'utilities/hash';

class UserValidator extends BaseValidator {
  properties = [
                 'name',
                 'password', 'password_confirmation',
                 'email'
               ];
  validEmail(){
    let email   = this.newVal.inputs.email.value;
    let isValid = isEmail(email);
    let message;
    if(!isValid){
      this.newVal.error = true;
      message = this.messages.user.email.valid;
    }
    this.addMessage(this.newVal.inputs.email, message);
    return this.newVal
  }
  validPassword(){
    let password   = this.newVal.inputs.password.value;
    let isValid = /^[A-Za-z0-9\d=!\-@._*]{8,64}$/.test(password)
    let message;
    if(!isValid){
      this.newVal.error = true;
      message = this.messages.user.password.valid;
    }
    this.addMessage(this.newVal.inputs.password, message);
    return this.newVal
  }
  validPasswordConfirmation(){
    let password              = this.newVal.inputs.password.value;
    let password_confirmation = this.newVal.inputs.password_confirmation.value;
    let isValid = password === password_confirmation
    let message;
    if(!isValid){
      this.newVal.error = true;
      message = this.messages.user.password_confirmation.same;
    }
    this.addMessage(this.newVal.inputs.password_confirmation, message);
    return this.newVal
  }
  validName(){
    let name = this.newVal.inputs.name.value;
    let isValid = this.require('name', this.messages.common.require)
    if(!isValid){
      this.newVal.error = true;
    }
  }
  validRole(){
    let items = this.newVal.inputs.role.items
    let message = this.messages.common.require_one;
    let isValid = false;
    for(var key in items){
      let item = items[key];
      if(item.value == '1'){
        message = null;
        isValid = true;
        break;
      }
    }
    if(!isValid){
      this.newVal.error = true;
    }
    this.addMessage(this.newVal.inputs.role, message);
  }
}
export const validUser = function*(){
  yield takeEvery(VALID_USER, function*(action: FSA<any, any>){
    let validator;
    validator = new UserValidator().init(action);
    let method = validator.newVal.method
    let newVal = { error: false };
    if(validator.targetIs('name')){
      validator.validName();
    }
    if(validator.targetIs('role')){
      validator.validRole();
    }
    if(validator.targetIs('email')){
      validator.validEmail();
      if(!newVal.error){
        yield validator.uniqueEmail();
      }
    }
    // パスワードは作成の時は必ず必要。更新の時は空の場合は不要だが、一文字でも入っていれば必要。
    if(method == 'POST' || validator.newVal.inputs.password.value != ''){
      if(validator.targetIs('password')){
        validator.validPassword();
      }
      if(validator.targetIs('password_confirmation')){
        validator.validPasswordConfirmation();
      }
    }
    let newData = newDataFromDot(validator.newVal, action.payload.baseScope)
    yield put(update(newData));
    validator.done();
  });
}
